//-------------------------------------------------------------------------
// Search Module
//-------------------------------------------------------------------------
var EICDataStream3Search = angular.module("EICDataStream3.search", ["EICDataStream3.config",
                                                                    "ui.router",
                                                                    "ngResource",
                                                                    "ngSanitize",
                                                                    "EICDataStream3.resources",
                                                                    "EICDataStream3.directives",
                                                                    "EICDataStream3.checkboxList",
                                                                 //   "EICDataStream3.legacyReportService",
                                                                    "EICDataStream3.memberNotes",
                                                                    "EICDataStream3.projectDisplay",
                                                                    "EICDataStream3.contractDisplay",
                                                                    "infinite-scroll",
                                                                    'datePicker',
                                                                    'ui.slider',
                                                                    "jqShowEffect",
                                                                    "truncate",
                                                                    "ui.directives",
                                                                    'ui.bootstrap',
                                                                    'eic.multiselect',
                                                                    'ngAnimate',
                                                                 //   'ngTouch', // ng Touch is deprecated https://docs.angularjs.org/api/ngTouch hamer.js??
                                                                    "dialogs.main"])
  .config(function () {
  })
    //.run(function($templateCache){
    //  $templateCache.put('/dialogs/custom.html','<div class="modal-header"><h4 class="modal-title"><span class="glyphicon glyphicon-star"></span> User\'s Name</h4></div><div class="modal-body"><ng-form name="nameDialog" novalidate role="form"><div class="form-group input-group-lg" ng-class="{true: \'has-error\'}[nameDialog.username.$dirty && nameDialog.username.$invalid]"><label class="control-label" for="course">Name:</label><input type="text" class="form-control" name="username" id="username" ng-model="user.name" ng-keyup="hitEnter($event)" required><span class="help-block">Enter your full name, first &amp; last.</span></div></ng-form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="cancel()">Cancel</button><button type="button" class="btn btn-primary" ng-click="save()" ng-disabled="(nameDialog.$dirty && nameDialog.$invalid) || nameDialog.$pristine">Save</button></div>');
    //  $templateCache.put('/dialogs/custom2.html','<div class="modal-header"><h4 class="modal-title"><span class="glyphicon glyphicon-star"></span> Custom Dialog 2</h4></div><div class="modal-body"><label class="control-label" for="customValue">Custom Value:</label><input type="text" class="form-control" id="customValue" ng-model="data.val" ng-keyup="hitEnter($event)"><span class="help-block">Using "dialogsProvider.useCopy(false)" in your applications config function will allow data passed to a custom dialog to retain its two-way binding with the scope of the calling controller.</span></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="done()">Done</button></div>');
    //});
    //.run(['$templateCache',function($templateCache) {
    //  $templateCache.put('/dialogs/whatsyourname.html',
    //      '<div class="modal">' +
    //        '<div class="modal-dialog">' +
    //          '<div class="modal-content">' +
    //            '<div class="modal-header">' +
    //              '<h4 class="modal-title"><span class="glyphicon glyphicon-star"></span> User\'s Name</h4>' +
    //            '</div>' +
    //              '<div class="modal-body">' +
    //                '<ng-form name="nameDialog" novalidate role="form">' +
    //                  '<div class="form-group input-group-lg" ng-class="{true: \'has-error\'}[nameDialog.username.$dirty && nameDialog.username.$invalid]">' +
    //                    '<label class="control-label" for="username">Name:</label>' +
    //                      '<input type="text" class="form-control" name="username" id="username" ng-model="user.name" ng-keyup="hitEnter($event)" required>' +
    //                    '<span class="help-block">Enter your full name, first &amp; last.</span>' +
    //                  '</div>' +
    //                '</ng-form>' +
    //              '</div>' +
    //              '<div class="modal-footer">' +
    //                '<button type="button" class="btn btn-default" ng-click="cancel()">Cancel</button>' +
    //                '<button type="button" class="btn btn-primary" ng-click="save()" ng-disabled="(nameDialog.$dirty && nameDialog.$invalid) || nameDialog.$pristine">Save</button>' +
    //            '</div>' +
    //          '</div>' +
    //        '</div>' +
    //      '</div>');
    //}])
    ;
// ,'ui.config',


//-------------------------------------------------------------------------
// In/Not in list Validator
// Parts copied and repurposed from the $setDirty() method
//-------------------------------------------------------------------------
EICDataStream3Search.directive('notAlreadyInList', function () {
    return {
      require: 'ngModel',
      link:    function (scope, elem, attrs, ctrl) {
        elem.on('keyup', function (evt) {
          var field = attrs.field;

          scope.$apply(function () {
            var currentItem = scope.$eval(attrs.notAlreadyInList)

            // form a temporary list for use in comparisons that  does not
            // contain the current search
            var list = scope[attrs.list].map(function(item){
              if(item.value != currentItem.searchGuid) return item;
            });


            var data = scope.$eval(attrs.data).trim().toLowerCase().replace(/\s{2,}/g, ' ');;

            ctrl.$setValidity('notAlreadyInList', true);
            for (var i = 0; i < list.length; i++) {
              if(!list[i]) continue;

              if (list[i][field].trim().toLowerCase() == data) {
                ctrl.$setValidity('notAlreadyInList', false);
                break;
              }
            }
          });
        });
      }

    };
});


//-------------------------------------------------------------------------
// formChanged Directive
// Whenever, the associated control is updated its status is
// reset back to  pristine.
// this is useful for controls that are being used in a validation
// context but which do not need to be illustrated as having
// been updated
//-------------------------------------------------------------------------
EICDataStream3Search.directive('onInteraction', ["$timeout",
  function ($timeout) {
  return {
    priority: 0,
    link: function (scope, elm, attrs) {
      var timer;
      elm.find(".projectCount").bind("keyup mouseup", function () {
      //scope.$parent.$eval(attrs.onInteraction);
        if(timer) $timeout.cancel(timer);
        timer = $timeout(function(){
          scope.$parent.$apply(attrs.onInteraction);
        }, 200);

    });

//      elm.find(":button").bind("keyup mouseup", function () {
//        scope.$parent.$eval(attrs.onInteraction);
//        //scope.$apply(attrs.onInteraction);
//      });

    }
  };
}]);




//-------------------------------------------------------------------------
// keepPristine Directive
// Whenever, the associated control is updated its status is
// reset back to  pristine.
// this is useful for controls that are being used in a validation
// context but which do not need to be illustrated as having
// been updated
//-------------------------------------------------------------------------
EICDataStream3Search.directive('keepPristine', function () {
  return {
    require: 'ngModel',
    link:    function (scope, elem, attrs, modelCtrl) {
      //watch model change
      scope.$watch(function () {
        return modelCtrl.$modelValue;
      }, function (newVal, oldVal) {
        //when directive initialize, newVal usually undefined.
        if (angular.isDefined(newVal)) {
          modelCtrl.$setPristine();
        }
      }, true);
    }
  };
});


var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty';

EICDataStream3Search.directive('proxyValidity', ["$animate",
  function ($animate) {
  return {
    require: 'ngModel',
    link:    function ($scope, $element, $attrs, modelCtrl) {
      if (typeof $element.prop('validity') === 'undefined')
        return;

      var parentForm = $element.inheritedData('$formController') || nullFormCtrl

      $scope.$watch("modelCtrl.$modelValue" , function(){
        if (!isNaN(modelCtrl.$modelValue)){
          // If the model has a value, then the control must be dirty,
          // so  set its initial state to allow the form validity to be
          // correctly evaluated
          setDirty();
          //
          // if (!$scope.$$phase){
          //   $scope.$apply();
          // }

        }
      });

      $element.on('keyup mouseup', function (evt) {
        var validity = $element.prop('validity');
        $scope.$apply(function () {
          if (validity.badInput && modelCtrl.$pristine){
            setDirty();
          }
          if(!validity.badInput && modelCtrl.$dirty) {
            modelCtrl.$setPristine();
          }

          modelCtrl.$setValidity('badInput', !(validity.badInput));
        });

      });


      var setDirty=function(){
        this.$dirty = true;
        this.$pristine = false;
        $animate.removeClass($element, PRISTINE_CLASS);
        $animate.addClass($element, DIRTY_CLASS);
        parentForm.$setDirty();
      };




    }
  };
}]);


//-------------------------------------------------------------------------
// ngConfirmClick Directive
//-------------------------------------------------------------------------
// Forces the user to confirm before carrying out an irreversile action
// such as deleting something
// Sample Usage:
//  <button type="button"
//    class="btn btn-danger"
//    confirmed-click="btnDelete(itemID);"
//    ng-confirm-click="Delete {{itemName}}. Are you sure?" >
//  Delete</button>
//-------------------------------------------------------------------------
EICDataStream3Search.directive('ngConfirmClick', [
  function() {
    return {
      link: function(scope, element, attr) {
        var clickAction = attr.confirmedClick;
        element.bind('click', function(event) {
          var msg = attr.ngConfirmClick || "Are you sure?";
          if (window.confirm(msg)) {
            scope.$eval(clickAction)
          }
        });
      }
    };
  }
]);


EICDataStream3Search.factory('QueryDefinition', ['$http',
  function ($http) {

     function QueryDefinition(){
       this.clear();
       // var queryDef = new Object;
       // this.sorting = {};
       // this.paging = {};
       // this.criteria = {};
      }

    QueryDefinition.prototype.clear = function () {
      this.guid ="";
      this.searchName = "";
      this.sorting = {sort_desc: false};
      this.paging = {limit: 20, offset: 0};
      this.criteria = {};
      this.searchFilters= [];
      this.searchSubject="";

      //this.sorting = {};
      //this.paging = {};
      //this.criteria = {};
    };

    QueryDefinition.prototype.incrementPage = function () {
      this.paging.offset = this.paging.offset + this.paging.limit;
    };

    QueryDefinition.prototype.apply = function (queryDef) {
      angular.extend(this, queryDef);
      //this.searchGuid ="";
      //this.searchName = "";
      //this.sorting = {sort_desc: false};
      //this.paging = {limit: 20, offset: 0};
      //this.criteria = {};
      //this.searchFilters= [];
      //this.searchSubject="";
    };
    return (QueryDefinition);
  }]);


EICDataStream3Search.factory('CriteriaSearch', ['QueryDefinition',
  function (QueryDefinition) {



    function CriteriaSearch() {
      this.queryDef = new QueryDefinition();
      this.addedFilters = [];
      this.removedFilters = [];
    };

    CriteriaSearch.prototype.setQueryDefinition = function (queryDef) {
      this.queryDef = queryDef;
    };



    CriteriaSearch.prototype.incrementPage = function () {
      this.queryDef.incrementPage();
    };

    CriteriaSearch.prototype.clear = function () {
      this.queryDef.clear();
      this.addedFilters = [];
      this.removedFilters = [];
    };

    return (CriteriaSearch);
  }]);



//EICDataStream3Search.factory('WatchList', ['QueryDefinition',
//  function (QueryDefinition) {

//    function WatchList() {
//      this.queryDef = new QueryDefinition();
//      this.itemList = [];
//    };

//    WatchList.prototype.setQueryDefinition = function (queryDef) {
//      this.queryDef = queryDef;
//    };

//    WatchList.prototype.setItemList = function (itemList) {
//      this.itemList = itemList;
//    };

//    WatchList.prototype.incrementPage = function () {
//      this.queryDef.incrementPage();
//    };

//    return (WatchList);
//  }]);




//-------------------------------------------------------------------------
// Search Controller
//-------------------------------------------------------------------------
EICDataStream3Search.controller('SearchController', ['$scope', 'searchService', '$timeout', 'queryBuilderService',
  function ($scope, searchService, $timeout, queryBuilderService) {
    $scope.componentName = "SearchController";
    $scope.searchService = searchService;

    searchService.queryDef.clear();
    //searchService.queryDef = new Object();
    //searchService.queryDef.sorting = {};
    //searchService.queryDef.paging = {};
    //searchService.queryDef.criteria = {};

    queryBuilderService.addedFilters = [];
    queryBuilderService.removedFilters = [];

    // If there are any changes to the criteria in the query definition
    // fire a call to find the potential results count.

// A pending request is cancelled if:
    // a. the new and old values are undefined
    // b. the newValue is an empty object
    // c. (future refinement) the new and old values are the same (nothing actually changed)

    $scope.$watch("searchService.queryDef.criteria", function(newVal, oldVal){
      if(!newVal && !oldVal) return;
      if (Object.keys(newVal).length === 0) return;
        searchService.getPotentialResultCount();
    }, true);


    $scope.$on('$viewContentLoaded', function () {
    });
    $scope.$on('$destroy', function () {
    });
  }]);




// Instead of all that tedious mucking about with services trying to inherit
// from each other, a better answer might be to break the functions of the
// projectDataService down into mor manageable chunks that are a better fit
// for the summary controllers...

// ... then the specific controller can inject the appropriate data services
// and it is the controller's responsibility to adapt the data to suit
// the HTML template.


//-------------------------------------------------------------------------



//-------------------------------------------------------------------------
// Contracts
//-------------------------------------------------------------------------


EICDataStream3Search.factory('contractDataService', ['$rootScope', '$timeout', '$state', '$stateParams', 'savedSearches', 'contract', 'contractAwards', 'searchService',
  function ($rootScope, $timeout, $state, $stateParams, savedSearches, contract, contractAwards, searchService) {
    var contractDataService = {};

    contractDataService.searchURL = "";

    contractDataService.contractID = 0;

    contractDataService.contract = null;
    contractDataService.isContract = false;


    contractDataService.getContract = function (contractID) {
      contract.get({ id: contractID }).$promise
        .then(function (item) {
          contractDataService.contract = item;

        });
    };


    // some locals
    contractDataService.busy = false;
    contractDataService.loading = true;
    contractDataService.items = [];
    contractDataService.contractDescriptions = [];
    contractDataService.totalResultsCount = 0;
    contractDataService.moreSummaries = false;


    contractDataService.nextPage = function () {
      // Guard conditions to prevent a search from runnning
      // i. search already in progress
      // ii. change of subject causing a nexpPage() call with no search criteria
      if (contractDataService.busy) return;
      if (Object.keys(searchService.queryDef.criteria).length == 0) return;

     // searchService.queryDef.paging.offset = searchService.queryDef.paging.offset + searchService.queryDef.paging.limit;
      searchService.queryDef.incrementPage();

      contractDataService.contractAwardSearch();
    };


    // other resource interface functions here...
    contractDataService.search = function (searchGuid) {
      if (!contractDataService.isContract) {

        contractDataService.cancelLoading = true;

        savedSearches.get({ guid: searchGuid }, startSearch,
          function () {
            showDataErrorMessage("There was an error and the search failed to start");
          }
        );

      }
    };


    var startSearch = function (savedSearchDefinition) {
      if (savedSearchDefinition.resubmit) {
        $state.go("search.contractAwardSummary", {guid: savedSearchDefinition.searchGuid, name: savedSearchDefinition.searchName})
      }

      searchService.queryDef.apply(savedSearchDefinition);

      contractDataService.cancelLoading = false;
      contractDataService.totalResultsCount = 0;
      contractDataService.items = [];
      contractDataService.projectNames = [];
      contractDataService.moreSummaries = false;

      contractDataService.contractAwardSearch();
    };


    var showDataErrorMessage = function (message) {
      projectDataService.dataErrorMessage = message;
      $timeout(function () {
        projectDataService.dataErrorMessage = "";
      }, 5000);
    };


    contractDataService.contractAwardSearch = function () {
        // Cancel loading is typically set to avoid a residual page fro being loaded
        // by InfiniteScroll when the route is changed and a new search is about to begin
        //if (contractDataService.cancelLoading) return;

      if (searchService.queryDef.criteria && searchService.queryDef.criteria != "") {
        contractDataService.busy = true;
        contractDataService.loading = true;
        contractAwards.query({ guid: searchService.queryDef.guid,
                                   paging: JSON.stringify(searchService.queryDef.paging),
                                  sorting: JSON.stringify(searchService.queryDef.sorting)}, // jsonSearchSpecification: JSON.stringify(searchService.queryDef) },
          function (items) {
            contractDataService.loading = false;

            contractDataService.items = contractDataService.items.concat(items[0].summaries);

            // The result count is only provided when the first page is sent
            // Subsequent pages do  not need the overhead of continually
            // recalculating the project count.
            // This may  become a name-like property in the future, like we
            // have with project summaries
            if(items[0].totalResultsCount){
              contractDataService.contractDescriptions = items[0].contractDescriptions;
              contractDataService.totalResultsCount = items[0].totalResultsCount;
            }

            contractDataService.moreSummaries = contractDataService.totalResultsCount > contractDataService.items.length;

            contractDataService.busy = false;
          },
          function () {
            showDataErrorMessage("There was an error and the next page of data failed to load");
          });
      }

    };

    contractDataService.formatContractDescription = function (shortContractType, contractorName, projectName) {
      return (shortContractType + "-" + contractorName + "-" + projectName).urlEncode();
    };

    return contractDataService;
  }]);
//-------------------------------------------------------------------------















